export default "__VITE_ASSET__BXeZTIYh__"